export const HeaderCell = ({ children }) => {
  return children;
};
